import type { Aabb } from "./types";

export type BoxDef = {
  cx: number; cy: number; cz: number;
  sx: number; sy: number; sz: number;
  color: number;
};

export const GROUND_SIZE = 80;

export const MAP_BOXES: BoxDef[] = [
  { cx: 0,   cy: 2,   cz:  40,  sx: 80, sy: 4, sz: 1,  color: 0x886644 },
  { cx: 0,   cy: 2,   cz: -40,  sx: 80, sy: 4, sz: 1,  color: 0x886644 },
  { cx:  40, cy: 2,   cz:  0,   sx: 1,  sy: 4, sz: 80, color: 0x886644 },
  { cx: -40, cy: 2,   cz:  0,   sx: 1,  sy: 4, sz: 80, color: 0x886644 },
  { cx:  8,  cy: 1,   cz:  0,   sx: 4,  sy: 2, sz: 4,  color: 0xb05050 },
  { cx: -8,  cy: 0.5, cz:  6,   sx: 3,  sy: 1, sz: 3,  color: 0x5070b0 },
  { cx: -12, cy: 1.5, cz: -8,   sx: 4,  sy: 3, sz: 4,  color: 0xb09040 },
  { cx:  14, cy: 0.5, cz: -14,  sx: 6,  sy: 1, sz: 6,  color: 0x70b070 },
  { cx:  0,  cy: 1.5, cz: -20,  sx: 8,  sy: 3, sz: 2,  color: 0x9050b0 },
  { cx:  14, cy: 2.5, cz:  12,  sx: 2,  sy: 5, sz: 2,  color: 0x303030 },
];

export function buildMapColliders(): Aabb[] {
  const out: Aabb[] = [];
  const half = GROUND_SIZE / 2;
  out.push({
    min: { x: -half, y: -1, z: -half },
    max: { x:  half, y:  0, z:  half },
  });
  for (const b of MAP_BOXES) {
    out.push({
      min: { x: b.cx - b.sx / 2, y: b.cy - b.sy / 2, z: b.cz - b.sz / 2 },
      max: { x: b.cx + b.sx / 2, y: b.cy + b.sy / 2, z: b.cz + b.sz / 2 },
    });
  }
  return out;
}
